import { render, staticRenderFns } from "./SalesData.vue?vue&type=template&id=7fe205b5&scoped=true&lang=pug&"
import script from "./SalesData.vue?vue&type=script&lang=js&"
export * from "./SalesData.vue?vue&type=script&lang=js&"
import style0 from "./SalesData.vue?vue&type=style&index=0&id=7fe205b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe205b5",
  null
  
)

export default component.exports